import { API, Auth } from 'aws-amplify';
import React, { FC, useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router';
import { RootState, useDispatch, useSelector } from 'src/store';
import { buttonsReset } from 'src/store/modules/buttons';

import { editTextReset } from 'src/store/modules/editText';
import { editCurrentIndex, imageReset } from 'src/store/modules/imageUpload';
import setInitValue from 'src/utils/setInitValue';
import { changeEnter } from 'src/utils/changeEnter';
import { initTrackingValues } from '../TemplateTracking/ImageBottomSheetTracking';
import { editUserCompany } from 'src/store/modules/client';
import { trackingReset } from 'src/store/modules/trackings';
import { getFontURL } from 'src/utils/getFontUrl';

const TEXT_2_JUSTIFY = {
  left: 'start',
  center: 'center',
  right: 'end'
};

const initViewValues = {
  currentIndex: 0,
  bgImage: {
    background: 'https://i.ibb.co/QbG5ZmB/image_bottom_sheet_1.png'
  },
  bgImageBlur: { background: 0 },
  radius: { background: 16, button: 32 },
  deeplink: { background: 'https://www.inappmessage.com/' },

  text: {
    title: '지금 날씨에 딱인 포근한 데일리 아우터',
    sub_title:
      '감기가 걱정되는 간절기에 당신의 건강과 따스한 온기를 보태줄 데일리 아우터 기획전'
  },
  fontSize: { title: 1.25, sub_title: 0.75 },
  fontWeight: { title: 700, sub_title: 400 },
  color: { title: '#000000', sub_title: '#828282' },
  fontFamily: { title: 'Montserrat', sub_title: 'Montserrat' },
  textAlign: { title: 'left', sub_title: 'left' },

  btnText: { button: '상품 보러가기' },
  btnFontSize: { button: 0.875 },
  btnFontWeight: { button: 500 },
  btnColor: { button: '#ffffff' },
  btnBgColorR: { button: 0 },
  btnBgColorG: { button: 0 },
  btnBgColorB: { button: 0 },
  btnBgColorA: { button: 0.7 },
  btnFontFamily: { button: 'Montserrat' }
};

const ImageBottomSheet: FC = () => {
  const dispatch = useDispatch();
  const [currentUser, setCurrentUser] = useState('');
  useEffect(() => {
    async function getUserId() {
      try {
        const current = await Auth.currentUserInfo();
        setCurrentUser(current.attributes['custom:Company']);
        dispatch(editUserCompany(current.attributes['custom:Company']));
      } catch (error) {
        console.log('error');
      }
    }
    getUserId();
  }, []);

  var templateWidth = useSelector(
    (state: RootState) => state.template.templateWidth
  );
  var currentIndex = useSelector(
    (state: RootState) => state.imageUpload.currentIndex
  );
  var bgImage = useSelector((state: RootState) => state.imageUpload.bgImage);
  var bgImageBlur = useSelector(
    (state: RootState) => state.imageUpload.bgImageBlur
  );
  var radius = useSelector((state: RootState) => state.imageUpload.radius);
  var deeplink = useSelector((state: RootState) => state.imageUpload.deeplink);

  var text = useSelector((state: RootState) => state.editText.text);
  var fontSize = useSelector((state: RootState) => state.editText.fontSize);
  var fontWeight = useSelector((state: RootState) => state.editText.fontWeight);
  var color = useSelector((state: RootState) => state.editText.color);
  var fontFamily = useSelector((state: RootState) => state.editText.fontFamily);
  var textAlign = useSelector((state: RootState) => state.editText.textAlign);

  var btnText = useSelector((state: RootState) => state.buttons.btnText);
  var btnFontSize = useSelector(
    (state: RootState) => state.buttons.btnFontSize
  );
  var btnFontWeight = useSelector(
    (state: RootState) => state.buttons.btnFontWeight
  );
  var btnColor = useSelector((state: RootState) => state.buttons.btnColor);
  var btnBgColorR = useSelector(
    (state: RootState) => state.buttons.btnBgColorR
  );
  var btnBgColorG = useSelector(
    (state: RootState) => state.buttons.btnBgColorG
  );
  var btnBgColorB = useSelector(
    (state: RootState) => state.buttons.btnBgColorB
  );
  var btnBgColorA = useSelector(
    (state: RootState) => state.buttons.btnBgColorA
  );
  var btnFontFamily = useSelector(
    (state: RootState) => state.buttons.btnFontFamily
  );
  const titleFontURL = getFontURL(fontFamily?.title);
  const subTitleFontURL = getFontURL(fontFamily?.sub_title);
  const btnURL = getFontURL(btnFontFamily?.button);
  // const titleFontURL = `https://workspace.inappmessage.com/${currentUser}/font/${fontFamily?.title}`;
  // const subTitleFontURL = `https://workspace.inappmessage.com/${currentUser}/font/${fontFamily?.sub_title}`;
  // const btnURL = `https://workspace.inappmessage.com/${currentUser}/font/${btnFontFamily?.button}`;
  const { id } = useParams<{ id: string }>();
  useEffect(() => {
    async function onLoad() {
      try {
        if (id) {
          const { customValues } = await API.get(
            'iam-editor',
            `/templates/${id}`,
            ''
          );
          setInitValue(dispatch, customValues);
        }
      } catch (error) {
        console.log(error);
      }
    }
    setInitValue(dispatch, { ...initViewValues, ...initTrackingValues });
    onLoad();
    return () => {
      dispatch(buttonsReset());

      dispatch(editTextReset());
      dispatch(imageReset());
      dispatch(trackingReset());
    };
  }, []);
  // useEffect(() => {
  //   async function getUserId() {
  //     const current = await Auth.currentUserInfo();
  //     setCurrentUser(current.attributes['custom:Company']);
  //   }
  //   getUserId();
  // }, []);

  const closeImageUrl = 'https://i.ibb.co/BTbz6mq/xmark.png';
  const style = `
  @font-face {
    font-family: 'title';
    src: url(${titleFontURL});
  }
  @font-face {
    font-family: 'subTitle';
    src: url(${subTitleFontURL});
  }
  @font-face {
    font-family: 'btn';
    src: url(${btnURL});
  }

    a {
      color: #000000;
      text-decoration: none;
      cursor: pointer;
    }

  .root_view {
    width: 100%;
    height: 100%;
    
    position: relative;
    background: none;
    overflow: hidden;
    
    .background {
      width: 100%;
      height: 100%;

      position: absolute;
      top: 0;
      background: rgba(0, 0, 0, 0.8);
    }
    .modal_wrapper {
      ${
        bgImage?.background || bgImage?.background !== ''
          ? `background-image: url(${bgImage?.background});`
          : `background: rgba(0, 0, 0, 0.8);`
      };
      width: 100%;
      height: 17rem;
      padding: 1rem 10% 1.5rem 10%;

      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      position: relative;

      position: absolute;
      bottom: 0;

      overflow: hidden;
      border-radius: ${radius?.background}px ${radius?.background}px 0 0;
    }

    .close_btn {
      width: 100%;
      display: flex;
      justify-content: end;
    }
    .close_btn button {
      width: 1.5rem;
      height: 1.5rem;
      
      background-image: url(${closeImageUrl});
      background-repeat: no-repeat;
      background-size: 1.5rem;
      background-position: center;

      font-size: 0;
      border: none;
      background-color: transparent;
    }

    .contents_box {
      height: calc(100% - 2rem);
      margin-top: 0.5rem;

      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
    .contents_box .title {
      width: 100%;
      height: 4rem;

      display: flex;
      align-items: center;
      justify-content: ${TEXT_2_JUSTIFY[textAlign?.title]};
    }
    .contents_box .title_inner {
      height: auto;
      max-height: 3.5rem;

      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;

      text-align: ${textAlign?.title};
      color: ${color?.title};
      font-size: ${fontSize?.title}rem;
      font-weight: ${fontWeight?.title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins'].includes(fontFamily?.title)
          ? fontFamily.title
          : 'title'
      };
    }

    .contents_box .sub_title {
      width: 100%;
      height: 3rem;

      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;

      text-align: ${textAlign?.sub_title};
      color: ${color?.sub_title};
      font-size: ${fontSize?.sub_title}rem;
      font-weight: ${fontWeight?.sub_title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins'].includes(
          fontFamily?.sub_title
        )
          ? fontFamily.sub_title
          : 'subTitle'
      };
    }

    .btn_wrapper button {
      padding: 0.65rem 1rem;
      border: 0;

      cursor: pointer;
      border-radius: ${radius?.button}px;
      background-color:rgba(${btnBgColorR?.button},${btnBgColorG?.button}, ${
    btnBgColorB?.button
  }, ${btnBgColorA?.button});

      font-size: ${btnFontSize?.button}rem;
      font-weight: ${btnFontWeight?.button};
      color: ${btnColor?.button};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins'].includes(
          btnFontFamily?.button
        )
          ? btnFontFamily?.button
          : 'btn'
      };
    }

    ${
      templateWidth > 767
        ? `
        .modal_wrapper {
          height: 29.065rem;
          padding: 2rem 25% 4rem 25%;
        }
        
        .contents_box {
          margin-top: 1.5rem;
        }
        .contents_box .title {
          height: 6rem;
        }
        .title_inner {
          font-size: ${fontSize?.title + 0.125}rem;
        }
        .contents_box .sub_title {
          height: 4rem;
          -webkit-line-clamp: 4;
        }
        `
        : ``
    }
  }
  `;

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: style }}></style>
      <div className="root_view">
        <div className="background"></div>
        <div className="modal_wrapper">
          <div className="close_btn">
            <button>close</button>
          </div>
          <div className="contents_box">
            <div>
              <div className="title">
                <div className="title_inner">{changeEnter(text?.title)}</div>
              </div>
              <div className="sub_title">{changeEnter(text?.sub_title)}</div>
            </div>
            <div className="btn_wrapper">
              <button>{btnText?.button}</button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ImageBottomSheet;
